import { useState } from 'react';

import { createName } from '@/utils/create-name';

import { PlaygroundButton } from './PlaygroundButtons';
import { SaveDatasetModal } from './SaveDatasetModal';
import { useSaveDataset } from './hooks/useSaveDataset';

export const SaveDatasetButton = ({
  isNewDataset,
}: {
  isNewDataset: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const [datasetName, setDatasetName] = useState(createName('ds'));
  const { saveDataset, isLoading, disabledMessage } = useSaveDataset({
    newDatasetName: isNewDataset ? datasetName : undefined,
  });

  return (
    <>
      <PlaygroundButton
        text={isLoading ? 'Saving...' : 'Save'}
        tooltipTitle={disabledMessage || 'Save dataset'}
        onClick={() => {
          if (isNewDataset) {
            setOpen(true);
          } else {
            saveDataset();
          }
        }}
        disabled={!!disabledMessage}
        className="border-brand py-1 text-brand-tertiary"
      />
      <SaveDatasetModal
        open={open}
        onClose={() => {
          setOpen(false);
          setDatasetName(createName('ds'));
        }}
        isLoading={isLoading}
        onSave={async () => {
          await saveDataset();
          setOpen(false);
        }}
        datasetName={datasetName}
        setDatasetName={setDatasetName}
      />
    </>
  );
};
